var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-no-results-message-box",class:{ absolute: _vm.absolute }},[_vm._v(" "+_vm._s(_vm.$t('message'))+" "),_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.search))])])
}
var staticRenderFns = []

export { render, staticRenderFns }